
import { DialogKey } from '../../types';

export const dialog: Record<DialogKey, string> = {
  unsavedChanges: 'Unsaved Changes',
  unsavedChangesMessage: 'You have unsaved changes. Do you really want to leave?',
  leaveAnyway: 'Leave Anyway'
};
